import React from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import Btn from 'components/Btn'
import * as Icons from '@iconscout/react-unicons'
import { withTranslation } from 'react-i18next'
import { setLoading } from 'store/slices/miscSlice'
import { destructureErrorMessage } from 'Helper'
import { useNavigate } from 'react-router-dom'


export default withTranslation()(function Logout({ handleClick, t }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const logout = async () => {
    dispatch(setLoading())
    try {
      // await apiRequest({
      //   url: 'auth/logout',
      //   method: 'post'
      // })

      localStorage.removeItem('__ra_pos')
      localStorage.removeItem('__ra_pos_refresh')
      toast.success(t('misc.logout.success'))
      navigate('/')
    } catch ({ message }) {
      // toast.error(t('misc.logout.failed'))
      destructureErrorMessage(message).map(msg => {
        // alert(msg)
        return toast.error(msg, { autoClose: 15000 })
      })
    }

    dispatch(setLoading('close'))
  }

  return (
    <div className={`fixed inset-0 z-[5000] bg-black bg-opacity-30 flex items-center justify-center p-4 text-center`} onClick={handleClick}>
      <div className="bg-white relative p-10 py-5 w-11/12 max-h-[90vh] overflow-y-auto rounded-xl lg:max-w-[400px]" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-2xl font-bold text-dark-blue mb-8">{t('misc.logout.title')}</h3>

        <Btn
          className="w-10 h-10 absolute right-2 top-1 hover:bg-default"
          content={() => <>
            <Icons.UilTimes className="text-secondary" />
          </>
          }
          click={handleClick}
        />



        <p className="mb-7">{t('misc.logout_confirmation')}</p>

        <div className="flex justify-between w-11/12 mx-auto lg:w-3/4">
          <Btn
            content={t('misc.cancel')}
            className="w-28 h-12 text-primary rounded-xl border border-primary"
            click={handleClick}
            variant="outlined"
          />

          <div className="overflow-hidden h-12">
            <Btn
              content={t('continue')}
              className="w-28 h-12 text-white rounded-xl bg-danger"
              click={logout}
            />
          </div>
        </div>
      </div>
    </div>
  )
})
